export default __webpack_public_path__ + "static/media/BOD Special Organizational Meeting 05 March 2021.21f14e60.pdf";